export default __webpack_public_path__ + "static/media/policyB.53b6723a.png";